import type { PostHog } from 'posthog-js/react';

import { getAnalytics } from '../utils/analytics';

export { getAnalytics };

/**
 * Custom hook that accesses analytics instance from window.analytics
 * (loaded via HTML script tag).
 *
 * This hook provides access to analytics for opt-in/opt-out, user identification,
 * initialization, and custom event capture.
 *
 * Use this hook inside React components. For use outside React components,
 * use `getAnalytics()` instead.
 *
 * @returns Analytics instance or null if not available
 */
export function useAnalytics(): PostHog | null {
  return getAnalytics();
}
